import React, { useState } from "react";
import { Button, Input, Modal, Tooltip, Typography } from "antd";
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
import GroupSubscriptionAction from "./GroupSubscriptionAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getCurrentIdentityGroupsRecursively } from "../../actions/api";

const SubscriptionButton = ({
  group,
  disabled,
  handleRefreshMembers = () => {},
  tooltipMessage = "",
}) => {
  const [open, setOpen] = useState(false);
  const [reasonValue, setReasonValue] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const groupMemberships = useSelector(
    (state) => state.groupMembership?.direct
  );
  const groupsIOwn = useSelector((state) => state.groups?.groupsIOwn);
  const groupMembershipsRecursive = useSelector(
    (state) => state.groupMembership?.recursive
  );
  const requests = useSelector((state) => state.requests?.my);

  const belongsToGroup = groupMemberships?.some((m) => group.id === m.id);

  const isAdmin = [
    ...groupsIOwn?.map((g) => g.id),
    ...groupMembershipsRecursive?.map((g) => g.id),
  ].includes(group?.administratorsId);

  const toggleBelongsToGroup = () => {
    dispatch(getCurrentIdentityGroupsRecursively());
  };

  const getButtonProps = () => {
    const buttonProps = {
      type: "primary",
      children: "Subscribe",
      onClick: () => setOpen(true),
    };

    const pendingSubscriptionRequest = requests?.find(
      (item) =>
        item.targetId1 === group.id && item.status.toLowerCase() === "pending"
    );

    if (pendingSubscriptionRequest) {
      buttonProps.children = "Pending";
      buttonProps.style = { background: "#faad14" };
      buttonProps.onClick = () => {
        navigate(`/requests/${pendingSubscriptionRequest.id}`);
      };
    }

    return buttonProps;
  };

  const renderActionButton = () => {
    const buttonProps = getButtonProps();

    return <Button id="subscribeButton" disabled={disabled} {...buttonProps} />;
  };

  return group.approvalRequired && !belongsToGroup && !isAdmin ? (
    <>
      {renderActionButton()}
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        centered
        title={
          <Typography.Title level={5} style={{ margin: 0 }}>
            <EditOutlined style={{ marginRight: 8 }} /> Subscribe to group:{" "}
            <Typography.Text type="secondary" style={{ fontSize: "inherit" }}>
              {group.groupIdentifier}
            </Typography.Text>
          </Typography.Title>
        }
        footer={[
          <Button
            key="cancel"
            onClick={() => setOpen(false)}
            icon={<CloseOutlined />}
            danger
            type="primary"
          >
            Cancel
          </Button>,
          <GroupSubscriptionAction
            key="subscribe"
            belongsToGroup={belongsToGroup}
            toggleSubscription={toggleBelongsToGroup}
            closeModal={() => setOpen(false)}
            disabled={disabled || !reasonValue.trim()}
            groupId={group.id}
            selfSubscriptionType={group.selfSubscriptionType}
            reason={reasonValue}
            syncType={group.syncType}
            handleRefreshMembers={handleRefreshMembers}
          />,
        ]}
      >
        <div style={{ marginBottom: 12 }}>
          <label>
            Approval is required to join this group. Please enter a reason for
            your request:
          </label>
        </div>
        <Input
          id="subscriptionReasonInput"
          onChange={(e) => setReasonValue(e.target.value)}
          value={reasonValue}
          placeholder="Subscription reason..."
        />
      </Modal>
    </>
  ) : (
    <Tooltip title={tooltipMessage} trigger={"hover"}>
      <GroupSubscriptionAction
        belongsToGroup={belongsToGroup}
        toggleSubscription={toggleBelongsToGroup}
        disabled={disabled}
        groupId={group.id}
        selfSubscriptionType={group.selfSubscriptionType}
        reason=""
        syncType={group.syncType}
        handleRefreshMembers={handleRefreshMembers}
      />
    </Tooltip>
  );
};

SubscriptionButton.propTypes = {
  group: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  handleRefreshMembers: PropTypes.func,
  tooltipMessage: PropTypes.string,
};

export default SubscriptionButton;
